<style>
	.pagination ::ng-deep .ngx-pagination .current {
		background: #e65100;
	}
</style>
<h1 class="page-header"><i class="fa fa-user" aria-hidden="true"></i> USERS</h1>
<div class="container-fluid">

	<div class="page-button">
		<button type="button" class="btn btn-ef" (click)="newUser()"><i class="fa fa-user-plus" aria-hidden="true"></i>
			ADD NEW USER</button>
		<span id="userOptionsBar"></span>

		<div class="btn-group edgefinityHeader">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
				aria-expanded="false">
				<i class="fa fa-wrench" aria-hidden="true"></i> ACTIONS <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li><a [routerLink]="'/customFields'" data-toggle="modal"><i class="fa fa-pencil-square"
							aria-hidden="true"></i> CUSTOM FIELDSs</a></li>
				<li class="divider"></li>
				<li (click)="editSelectedUser()" [class.disabled]="!isSingleUserSelected()"><a><em
							class="fa fa-pencil"></em> EDIT USER</a></li>
				<li (click)="deleteSelectedUsersClicked()" [class.disabled]="!isAnyUserSelected()"><a><em
							class="fa fa-pencil"></em> DELETE USERS</a></li>
				<li class="divider"></li>
				<li (click)="uploadFileClicked()"><input type="file" #fileUpload (change)="onFileUploadChange($event)"
						style="display:none" /><a><em class="fa fa-pencil"></em> UPLOAD USERS </a></li>
				<li (click)="downloadUsers()"><a><em class="fa fa-pencil"></em> DOWNLOAD USERS </a></li>
				<li>
                    <a [routerLink]="'/api-tokens'" data-toggle="modal" *ngIf="pagePermissionService.canRead(pagePermissionType.ApiTokenPage)">
                        <i class="fa fa-pencil-square" aria-hidden="true"></i> API TOKEN 
                    </a>
                </li>
			</ul>
		</div>

		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
				<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li (click)="setFilterUser(null, null)"><a>REMOVE FILTER</a></li>
				<li (click)="setFilterUser('User ID', 'name')"><a>User ID</a></li>
			</ul>
		</div>
		<div *ngIf="filterColumnUser != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			{{ filterColumnNameUser }}
		</div>
		<div *ngIf="filterColumnUser != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
				[(ngModel)]="filterStringUser" (ngModelChange)="filterStringChangedUser()">
		</div>

	</div>

	<div class="table-responsive" id="userTableHolder">
		<table class="table tablesorter tablesorter-default table-hover" id="table1">
			<thead>
				<tr>
					<th>&nbsp;</th>
					<th width="80px">IMAGE</th>
					<th>USER ID</th>
					<th>NAME</th>
					<th>EMAIL</th>
					<th>MOBILE</th>
					<th>ACTIVE</th>
					<th>ROLE TYPES</th>
					<th>MFA ENABLED</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let userTag of selectedUsers | paginate: { id: 'user_pagination', itemsPerPage: numberOfUsersPerPage, currentPage: currentPageUser, totalItems: totalNumberOfUsers }">
					<tr>
						<td>
							<div class="checkbox checkbox-inline">
								<input type="checkbox" [(ngModel)]="userTag.mSelected">
								<label></label>
							</div>
						</td>

						<!-- Profile Image -->
						<td (click)="editUser(userTag.user)"><img [src]="imageSource(userTag.user)" width="80"
								height="80" alt="{{userTag.user.firstName}}" /></td>

						<!-- User ID -->
						<td (click)="editUser(userTag.user)">{{userTag.user.login}}</td>

						<!-- Name -->
						<td (click)="editUser(userTag.user)">{{userTag.user.firstName}}&nbsp;{{userTag.user.lastName}}
						</td>

						<!-- Email -->
						<td (click)="editUser(userTag.user)">{{userTag.user.email}}</td>

						<!-- Mobile -->
						<td (click)="editUser(userTag.user)"
							*ngIf="userTag.user.cellNumber != null && userTag.user.cellNumber.length > 0">
							{{userTag.user.cellNumber}}</td>
						<td (click)="editUser(userTag.user)"
							*ngIf="userTag.user.cellNumber == null || userTag.user.cellNumber.length === 0">N/A</td>

						<!-- Active -->
						<td (click)="editUser(userTag.user)" *ngIf="userTag.user.isActive">TRUE</td>
						<td (click)="editUser(userTag.user)" *ngIf="!userTag.user.isActive">FALSE</td>

						<!-- Role Type -->
						<td (click)="editUser(userTag.user)">
							<ng-container *ngIf="userTag.user.groups != null && userTag.user.groups.length > 0">
								<ng-container *ngFor="let group of userTag.user.groups">
									{{group.name}}<br />
								</ng-container>
							</ng-container>
						</td>
						<!-- Multi Factor Authentication -->
						<td (click)="editUser(userTag?.user)">
							{{ userTag?.user?.twoFactorEnabled === true ? 'TRUE' : 'FALSE' }}
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
	<pagination-controls class="pagination" id="user_pagination"
		(pageChange)="pageChanged($event)" [directionLinks]="true" nextLabel="Next" previousLabel="Prev"
		[autoHide]="true">
	</pagination-controls>


</div>

<app-confirm-delete-dialog #confirmDeleteDialog (confirmEvent)="deleteConfirmed()"></app-confirm-delete-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>